import { Component, h, Prop, State } from "@stencil/core"
import { ItemRadioModel } from "./ItemsRadioListModel"

/**
 * The compnent to display the list with radio button.
 */
@Component({
  tag: "item-radio-list",
  styleUrl: "ItemsRadioList.scss",
})
export class ItemRadioList {
  /**
   * The list of items.
   */
  @Prop() itemList: ItemRadioModel[]

  /**
   *  Callback called after selecting item from the list.
   *
   * @param item Object with data about the selected item.
   */
  @Prop() setSelectedItem: (item: ItemRadioModel) => void

  @State() currentItem: ItemRadioModel

  componentWillLoad() {
    if (this.itemList && this.itemList.length > 0) {
      if (!this.currentItem) {
        this.setSelectedItemLocal(this.itemList[0])
      }
    }
  }

  setSelectedItemLocal = (item: ItemRadioModel) => {
    this.currentItem = item
    if (typeof this.setSelectedItem === "function") {
      this.setSelectedItem(item)
    }
  }

  isItemSelected = (item: ItemRadioModel): boolean => {
    return this.currentItem && item.label === this.currentItem.label
  }

  render() {
    const renderItem = (item: ItemRadioModel) => {
      return (
        <div
          class={"parent" + (this.isItemSelected(item) ? " selectedBorder" : "")}
          onClick={() => this.setSelectedItemLocal(item)}>
          <input class={"radioButton"} checked={this.isItemSelected(item)} type="radio"></input>
          <span class={"radioSpan"}></span>
          <div class="itemContent">
            <div class="label">{item.label}</div>
            {item.description && <div class="description">{item.description}</div>}
          </div>
        </div>
      )
    }

    return (
      <div>
        {this.itemList.length > 0 ? (
          this.itemList.map((item, index) => {
            return <div key={index}>{renderItem(item)}</div>
          })
        ) : (
          <div></div>
        )}
      </div>
    )
  }
}
